import { supabase } from '../../lib/supabase'
import { evaluateUnlocks } from '../../lib/unlocks'
import { runEngine } from '../../lib/constraints'
import { weeksLeft } from '../../lib/timeline'


// ── Feature unlocks ───────────────────────────────────────────────────────────
export const unlockSlice = (set, get) => ({
  unlocks:    new Set(),
  freshUnlock: null,  // key of most recently unlocked feature

  loadUnlocks: async () => {
    const uid = get().user?.id
    if (!uid) return
    const { data } = await supabase.from('feature_unlocks').select('feature_key').eq('user_id', uid)
    set({ unlocks: new Set((data ?? []).map(r => r.feature_key)) })
  },

  checkUnlocks: async () => {
    const { user, profile, goals, phases, reviews, unlocks } = get()
    if (!user || !profile) return

    const fresh = evaluateUnlocks({ profile, goals, phases, reviews, current: unlocks })
    if (!fresh.length) return

    await supabase.from('feature_unlocks').insert(
      fresh.map(k => ({ user_id: user.id, feature_key: k, unlocked_at: new Date().toISOString() }))
    )

    const next = new Set([...unlocks, ...fresh])
    set({ unlocks: next, freshUnlock: fresh[fresh.length - 1] })
  },

  has: (key) => get().unlocks.has(key),
  clearFresh: () => set({ freshUnlock: null }),
})

// ── Constraint snapshot ───────────────────────────────────────────────────────
export const constraintSlice = (set, get) => ({
  constraints: null,

  recompute: () => {
    const { goals, profile } = get()
    if (!profile) return
    const snap = runEngine({
      goals,
      avail:     profile.weekly_available_hours ?? 0,
      cap:       profile.active_goal_cap ?? 3,
      weeksLeft: weeksLeft(profile.date_of_birth, profile.expected_lifespan),
    })
    set({ constraints: snap })
    return snap
  },
})

// ── Timeline / canvas UI state ────────────────────────────────────────────────
export const timelineSlice = (set) => ({
  zoom:       'month',   // 'week' | 'month' | 'year' | 'decade'
  showDrift:  false,
  setZoom:    (z) => set({ zoom: z }),
  toggleDrift:() => set(s => ({ showDrift: !s.showDrift })),
})
